import gql from "graphql-tag";

export const getCurrencies = gql`
  {
    getCurrencies {
      id
      symbol
      isEnable
      isPayment
      isBaseCurrency
      status
    }
  }
`;

export const getCurrencyRates = gql`
  {
    getCurrencyRates {
      base
      rates
    }
  }
`;

export const updateSmsMethodMutation = gql`
  mutation(
    $id: Int!
    $status: String
    $accountId: String
    $securityId: String
    $phoneNumber: String
    $phoneDialCode: String
    $phoneCountryCode: String
    $updateStatus: Boolean
  ) {
    updateSmsMethod(
      id: $id
      status: $status
      accountId: $accountId
      securityId: $securityId
      phoneNumber: $phoneNumber
      phoneDialCode: $phoneDialCode
      phoneCountryCode: $phoneCountryCode
      updateStatus: $updateStatus
    ) {
      status
      errorMessage
    }
  }
`;

export const updateTempImagesMutation = gql`
  mutation updateTempImages(
    $tableName: String
    $fieldName: String
    $fileName: String
  ) {
    updateTempImages(
      tableName: $tableName
      fieldName: $fieldName
      fileName: $fileName
    ) {
      status
    }
  }
`;

export const getMapViewDataQuery = gql`
  query($id: String!, $period: String!, $limit: Int) {
    getMapViewData(id: $id, period: $period, limit: $limit) {
      status
      results {
        id
        userType
        isActive
        activeStatus
        profile {
          lat
          lng
        }
      }
    }
  }
`;

export const getHeatMapDataQuery = gql`
  query($id: String!, $period: String!, $limit: Int) {
    getHeatMapData(id: $id, period: $period, limit: $limit) {
      status
      results {
        id
        userType
        profile {
          lat
          lng
        }
      }
      bookingResults {
        id
        userLocationLat
        userLocationLng
      }
    }
  }
`;

export const getContentPageDetailsQuery = gql`
  query getContentPageDetails {
    getContentPageDetails {
      status
      errorMessage
      results {
        id
        metaTitle
        metaDescription
        pageUrl
        pageTitle
        content
        isEnable
        pageBanner
      }
    }
  }
`;

export const deleteContentPageMutation = gql`
  mutation deleteContentPage($id: Int!) {
    deleteContentPage(id: $id) {
      status
      errorMessage
    }
  }
`;

export const updateContentStatusMutation = gql`
  mutation updateContentPageStatus($id: Int, $isEnable: Boolean) {
    updateContentPageStatus(id: $id, isEnable: $isEnable) {
      status
      errorMessage
    }
  }
`;

export const updatePartnerMutation = gql`
  mutation updatePartner(
    $id: ID
    $firstName: String
    $lastName: String
    $email: String
    $phoneDialCode: String
    $phoneNumber: String
    $userStatus: String
    $isBan: Int
    $phoneCountryCode: String
    $preferredCurrency: String
    $companyName: String
    $workLicenceNumber: String
  ) {
    updatePartner(
      id: $id
      firstName: $firstName
      lastName: $lastName
      email: $email
      phoneDialCode: $phoneDialCode
      phoneNumber: $phoneNumber
      userStatus: $userStatus
      isBan: $isBan
      phoneCountryCode: $phoneCountryCode
      preferredCurrency: $preferredCurrency
      companyName: $companyName
      workLicenceNumber: $workLicenceNumber
    ) {
      status
      errorMessage
    }
  }
`;

export const getSiteSettingsQuery = gql`
  query getSiteSettings($type: String) {
    getSiteSettings(type: $type) {
      results {
        name
        value
      }
      status
      errorMessage
    }
  }
`;

export const updateSiteSettingsMutation = gql`
  mutation updateSiteSettings($favicon: String) {
    updateSiteSettings(favicon: $favicon) {
      status
      errorMessage
    }
  }
`;

export const updateHomePageCategoryMutation = gql`
mutation ($homePageCategoryList: categoryListInputType!,$dynamicTopFeatureSettings:[dynamicTopFeaturesSettingsInput]!) {
  updateHomePageCategory (homePageCategoryList: $homePageCategoryList,dynamicTopFeatureSettings:$dynamicTopFeatureSettings) {
  status
  errorMessage
  }
}`;

export const updateHomePageCityMutation = gql`
  mutation updateHomePageCity(
    $citySectionTitle1: String
    $citySectionContent1: String
    $dynamicCategoryTitle: [dynamicHomePageSettingsInput]
  ) {
    updateHomePageCity(
      citySectionTitle1: $citySectionTitle1
      citySectionContent1: $citySectionContent1
      dynamicCategoryTitle: $dynamicCategoryTitle
    ) {
      status
      errorMessage
    }
  }
`;

export const updateHomePageFooterMutation = gql`
  mutation updateHomePageFooter(
    $footerLogo1: String
    $footerLogo2: String
    $footerLogo3: String
    $footerLogo4: String
    $footerTitle1: String
    $footerContent1: String
    $footerLink1: String
    $footerLink2: String
    $footerLink3: String
    $footerLink4: String
    $footerLinkName1: String
    $footerLinkName2: String
    $footerLinkName3: String
    $footerLinkName4: String
    $footerLinkTitle: String
    $footerBottom: String
    $dynamicAppSettings: [dynamicHomePageSettingsInput]
  ) {
    updateHomePageFooter(
      footerLogo1: $footerLogo1
      footerLogo2: $footerLogo2
      footerLogo3: $footerLogo3
      footerLogo4: $footerLogo4
      footerTitle1: $footerTitle1
      footerContent1: $footerContent1
      footerLink1: $footerLink1
      footerLink2: $footerLink2
      footerLink3: $footerLink3
      footerLink4: $footerLink4
      footerLinkName1: $footerLinkName1
      footerLinkName2: $footerLinkName2
      footerLinkName3: $footerLinkName3
      footerLinkName4: $footerLinkName4
      footerLinkTitle: $footerLinkTitle
      footerBottom: $footerBottom
      dynamicAppSettings: $dynamicAppSettings
    ) {
      status
      errorMessage
    }
  }
`;

export const updateHomePageHomeMutation = gql`
  mutation updateHomePageHome(
    $homeSectionImage1: String
    $homeSectionImage2: String
    $homeSectionImage3: String
    $homeSectionImage4: String
    $homeSectionImage5: String
    $homeSectionImage6: String
    $homeSectionImage7: String
    $homeSectionImage8: String
    $homeSectionButton1: String
    $homeSectionTitle1: String
    $dynamicHomeBannerTitle: [dynamicHomePageSettingsInput]
  ) {
    updateHomePageHome(
      homeSectionImage1: $homeSectionImage1
      homeSectionImage2: $homeSectionImage2
      homeSectionImage3: $homeSectionImage3
      homeSectionImage4: $homeSectionImage4
      homeSectionImage5: $homeSectionImage5
      homeSectionImage6: $homeSectionImage6
      homeSectionImage7: $homeSectionImage7
      homeSectionImage8: $homeSectionImage8
      homeSectionButton1: $homeSectionButton1
      homeSectionTitle1: $homeSectionTitle1
      dynamicHomeBannerTitle: $dynamicHomeBannerTitle
    ) {
      status
      errorMessage
    }
  }
`;

export const updateHomePageSafetyMutation = gql`
  mutation updateHomePageSafety(
    $safetyGridImage1: String
    $safetyGridImage2: String
    $safetyGridImage3: String
    $safetyGridTitle1: String
    $safetyGridContent1: String
    $safetyGridLink1: String
    $safetyGridLink2: String
    $safetyGridImage4: String
    $dynamicAppSettings: [dynamicHomePageSettingsInput]
  ) {
    updateHomePageSafety(
      safetyGridImage1: $safetyGridImage1
      safetyGridImage2: $safetyGridImage2
      safetyGridImage3: $safetyGridImage3
      safetyGridTitle1: $safetyGridTitle1
      safetyGridContent1: $safetyGridContent1
      safetyGridLink1: $safetyGridLink1
      safetyGridLink2: $safetyGridLink2
      safetyGridImage4: $safetyGridImage4
      dynamicAppSettings: $dynamicAppSettings
    ) {
      status
      errorMessage
    }
  }
`;

export const updateHomePageSignup = gql`
  mutation updateHomePageSignup(
    $signupGridImage1: String
    $signupGridImage2: String
    $signupGridImage3: String
    $signupGridTitle1: String
    $signupGridContent1: String
    $signupGridLink1: String
    $signupGridLink2: String
    $signupGridImage4: String
    $dynamicAppSettings: [dynamicHomePageSettingsInput]
  ) {
    updateHomePageSignup(
      signupGridImage1: $signupGridImage1
      signupGridImage2: $signupGridImage2
      signupGridImage3: $signupGridImage3
      signupGridTitle1: $signupGridTitle1
      signupGridContent1: $signupGridContent1
      signupGridLink1: $signupGridLink1
      signupGridLink2: $signupGridLink2
      signupGridImage4: $signupGridImage4
      dynamicAppSettings: $dynamicAppSettings
    ) {
      status
      errorMessage
    }
  }
`;

export const updateMobileSettingsMutation = gql`
  mutation updateMobileSettings(
    $appForceUpdate: String
    $userAndroidVersion: String
    $userIosVersion: String
    $partnerAndroidVersion: String
    $partnerIosVersion: String
    $stripePublishableKey: String
    $allowableDistace: String
    $allowedServices: String
    $notificationInterval: String
    $sleepPartnerAndroid: String
    $sleepPartnerios: String
    $contactPhoneNumber: String
    $contactEmail: String
    $skype: String
    $maximumEmergencyContact: String
    $duration: String
    $job: String
    $photo: String
    $description: String
    $estimatedPrice: String
    $location: String
    $requestTimeTone: String
    $isRequestTimerToneEnable: String
    $openAppOnRequest: String
    $requestToneFile: String
    $defaultScheduleInterval: String
    $addtionalWorkInterval: String
  ) {
    updateMobileSettings(
      appForceUpdate: $appForceUpdate
      userAndroidVersion: $userAndroidVersion
      userIosVersion: $userIosVersion
      partnerAndroidVersion: $partnerAndroidVersion
      partnerIosVersion: $partnerIosVersion
      stripePublishableKey: $stripePublishableKey
      allowableDistace: $allowableDistace
      allowedServices: $allowedServices
      notificationInterval: $notificationInterval
      sleepPartnerAndroid: $sleepPartnerAndroid
      sleepPartnerios: $sleepPartnerios
      contactPhoneNumber: $contactPhoneNumber
      contactEmail: $contactEmail
      skype: $skype
      maximumEmergencyContact: $maximumEmergencyContact
      duration: $duration
      job: $job
      photo: $photo
      description: $description
      estimatedPrice: $estimatedPrice
      location: $location
      requestTimeTone: $requestTimeTone
      isRequestTimerToneEnable: $isRequestTimerToneEnable
      openAppOnRequest: $openAppOnRequest
      requestToneFile: $requestToneFile
      defaultScheduleInterval: $defaultScheduleInterval
      addtionalWorkInterval: $addtionalWorkInterval
    ) {
      status
      errorMessage
    }
  }
`;

export const updateToneMutation = gql`
  mutation updateTone {
    updateTone {
      status
    }
  }
`;

export const updateSettingsMutation = gql`
  mutation updateSiteSettings(
    $siteName: String
    $siteTitle: String
    $metaDescription: String
    $facebookLink: String
    $twitterLink: String
    $instagramLink: String
    $metaKeyword: String
    $homeLogo: String
    $youtubeLink: String
    $favicon: String
    $ogImage: String
    $headerCode: String
    $bodyCode: String
  ) {
    updateSiteSettings(
      siteName: $siteName
      siteTitle: $siteTitle
      metaDescription: $metaDescription
      facebookLink: $facebookLink
      twitterLink: $twitterLink
      instagramLink: $instagramLink
      metaKeyword: $metaKeyword
      homeLogo: $homeLogo
      youtubeLink: $youtubeLink
      favicon: $favicon
      ogImage: $ogImage
      headerCode: $headerCode
      bodyCode: $bodyCode
    ) {
      status
      errorMessage
    }
  }
`;

export const updateStaticPageMutation = gql`
  mutation updateStaticPage(
    $id: Int
    $content: String
    $metaTitle: String
    $metaDescription: String
    $pageBanner: String
    $dynamicStaticContent:[dynamicStaticContentInput]
  ) {
    updateStaticPage(
      id: $id
      content: $content
      metaTitle: $metaTitle
      metaDescription: $metaDescription
      pageBanner: $pageBanner
      dynamicStaticContent:$dynamicStaticContent
    ) {
      status
      errorMessage
    }
  }
`;

export const getEditStaticPageQuery = gql`
  query getEditStaticPage($id: Int!) {
    getEditStaticPage(id: $id) {
      result {
        id
        pageName
        content
        metaTitle
        metaDescription
        pageBanner
        createdAt
      }
    }
  }
`;

export const updateProfileImageMutation = gql`
  mutation uploadProfileImage($userId: ID, $picture: String) {
    uploadProfileImage(userId: $userId, picture: $picture) {
      status
    }
  }
`;

export const intlQuery = gql`
  query intl($locale: String!) {
    intl(locale: $locale) {
      id
      message
    }
  }
`;
